module.exports = __webpack_public_path__ + "static/media/Boar_meat.3763e1b9.png";